export const AUTH_API = "/v1/oauth2/token";
export const PAYPAL_SUBSCRIPTION = "/v1/billing/subscriptions";
export const PAYPAL_ORDER = "/v2/checkout/orders";
